
<template>

    <Head :title="title"></Head>

    <div id="layout" class="min-h-screen w-screen grid bg-light-blue relative">

        <Banner />


        <language-selector class="absolute top-4 right-4 z-40"
            style="grid-area: language_selector" />


        <Logo class="w-36 h-36 mb-4"
            href="https://pausefitness.kinsta.cloud/"
            style="grid-area: logo" />


        <h2 class="font-nexa text-3xl leading-[1.4em] text-blue mb-3 mt-3"
            style="grid-area: title">

            {{ title }}

        </h2>


        <div class="text-lg text-blue font-nexa"
             style="grid-area: description"
             v-if="description">

            {{ description }}

        </div>


        <div class="my-6"
             style="grid-area: form">

            <slot></slot>

        </div>


        <p class="text-xl font-sans text-blue leading-tight mt-auto"
            style="grid-area: health_tip">

            <span class="font-nexa">{{ __('Health tip') }}:</span>

            {{ __('Use a smaller plate, you will then automatically eat less') }}

        </p>


        <div class="bg-no-repeat hidden xl:flex flex-col justify-center items-center top-0 left-0 absolute"
             style="grid-area: heart; background-image: url('/images/heart.png'); width: 454px; height: 397px;">

            <p class="font-nexa text-white text-3xl mb-2 -mt-12 leading-normal">{{ __('3 minutes') }}</p>

            <p class="font-nexa text-white text-3xl leading-normal">{{ __('3 times a week') }}</p>

        </div>


        <div class="relative hidden xl:block w-full h-full bg-no-repeat bg-blue bg-opacity-80 overflow-hidden bg-contain bg-bottom"
             style="
                grid-area: birgitte;
                background-blend-mode: luminosity;
                background-image: url('/images/birgitte.png');
                -webkit-mask-image: url(/images/birgitte.png);
                -webkit-mask-size: contain;
                -webkit-mask-repeat: no-repeat;
                -webkit-mask-position: bottom;">
        </div>


    </div>

</template>

<script>

import { defineComponent } from "vue";
import Logo from '@/Components/Logo.vue';
import LanguageSelector from "@/Components/LanguageSelector.vue";
import Banner from '@/Components/Banner.vue';
import { Head } from '@inertiajs/inertia-vue3';

export default defineComponent({

    props: {
        title: String,
        description: String
    },


    components: {
        Head,
        Logo,
        Banner,
        LanguageSelector
    },

});

</script>

<style scoped>

#layout {
    grid-template-columns: 30px min-content auto 30px;
    grid-template-rows: 30px auto min-content min-content min-content auto 30px;
    grid-template-areas:
            ". . . ."
            ". logo . ."
            ". title title ."
            ". description description ."
            ". form form ."
            ". health_tip health_tip ."
            ". . . ."
    ;
}

@media (min-width: 768px) {
    #layout {
        grid-template-columns: 60px auto minmax(min-content,425px) auto 60px;
        grid-template-rows: 60px auto min-content min-content min-content auto 60px;
        grid-template-areas:
            ". . . . ."
            ". logo logo logo ."
            ". . title . ."
            ". . description . ."
            ". . form . ."
            ". health_tip health_tip health_tip ."
            ". . . . ."
    ;
    }
}

@media (min-width: 1280px) {

    #layout {
        grid-template-columns: 120px 426px auto 1fr;
        grid-template-rows: 110px min-content min-content min-content min-content auto 110px;
        grid-template-areas:
            ". . . ."
            ". logo heart birgitte"
            ". title . birgitte"
            ". description . birgitte"
            ". form . birgitte"
            ". health_tip health_tip birgitte"
            ". . . birgitte"
        ;
    }
}

</style>
